import {
  getRgbForStoredOverlayColor,
  rgbToCss,
} from "@/features/shared/widgets/model-map/static-overlay-color-presets";

import styles from "./static-overlay-color-swatch.module.css";

export interface StaticOverlayColorSwatchProps {
  /** Raw `color` from configuration (preset key or legacy value). */
  value: string;
}

/** Non-interactive preview of the resolved preset RGB for a stored color string. */
export function StaticOverlayColorSwatch({ value }: StaticOverlayColorSwatchProps) {
  return (
    <div
      className={styles.swatch}
      style={{ backgroundColor: rgbToCss(getRgbForStoredOverlayColor(value)) }}
      aria-hidden
    />
  );
}
